import UfoPildImg from "@shared/branding/theufolab/ufo-pild.png";

export function UfoPild() {
  return (
    <a href="https://theufolab.com" target="_blank" className="ufo-pild">
      <img src={UfoPildImg} alt="Powered by UFOLab" title="Powered by UFOLab" />
    </a>
  );
}
